/** @jsxImportSource @emotion/react */

import { Undo2 as Undo2Icon } from 'lucide-react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import history from 'ud-ui/components/fabric-canvas/addons/history';

import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal, selectFabricManager } from '../../../../store/editor/selectors';
import { IconButton, IconWrapper } from './styles';

export function Undo() {
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useSelector(selectFabricManager);
  const [isActive, setIsActive] = React.useState(history.isInit() ?? history.undoIsActive());

  const onClickUndo = () => {
    if (!fabricManager) return;
    history.undo();
  };

  useEffect(() => {
    history.history.subscribe(() => {
      setIsActive(history.undoIsActive());
    });
    history.index.subscribe(() => {
      setIsActive(history.undoIsActive());
    });
  }, []);

  return (
    <UDTippy disabled={Boolean(activeModal)} content={'Назад'} size="xs">
      <span style={{ display: 'inline-block' }}>
        <IconButton onClick={onClickUndo} disabled={!isActive} tabIndex={0}>
          <IconWrapper icon={<Undo2Icon size={20} strokeWidth={1.5} />} />
        </IconButton>
      </span>
    </UDTippy>
  );
}
